import { render, staticRenderFns } from "./settingGLAccountGroups.vue?vue&type=template&id=25af7510&scoped=true&"
import script from "./settingGLAccountGroups.vue?vue&type=script&lang=js&"
export * from "./settingGLAccountGroups.vue?vue&type=script&lang=js&"
import style0 from "./settingGLAccountGroups.vue?vue&type=style&index=0&id=25af7510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af7510",
  null
  
)

export default component.exports